export default __webpack_public_path__ + "static/media/img002.640eea77.png";